module.exports = __webpack_public_path__ + "img/live-score.50858864.png";